<template lang="">
    <div>
        <OnlineRenewalCardDetails ref="cardDetailsRef"
        :publishable-key="$store.state.stripePublishableKey"></OnlineRenewalCardDetails>
    </div>
</template>

<style lang="css" scoped>
    
</style>

<script>
/**
 * Request Model
 * @summary This model is responsible on creating the model for the appropriate request
 */
var InsitesRequestModels = (function(){
    var 
        billingDetails = function(){
            this.customer = new InsitesRequestModels.customer();
            this.address = new InsitesRequestModels.address() 
        },

        userPaymentDetails = function() {
            this.isUser = true;
            this.id = "";
            this.customer = "";
            this.source = "";
            this.currency = "AUD";
            this.amount = "";
            this.customer = new InsitesRequestModels.customer();
            this.address = new InsitesRequestModels.address();
            this.state_descriptor = "";
            this.description = "";
        },

        guestPaymentDetails = function () {
            this.customer = new InsitesRequestModels.customer();
            this.address = new InsitesRequestModels.address();
            this.source = "";
            this.currency = "AUD";
            this.amount = "";
            this.state_descriptor = "";
            this.description = "";
        }

    return {
        address: function () {
            this.isSaveBilling = false,
            this.address1 = "",
            this.address2 = "",
            this.city = "",
            this.address_state = "",
            this.post_code = "",
            this.country = ""
        },
        customer: function () { 
            this.id = "new",
            this.email =  "", 
            this.lastName = "", 
            this.firstName = "",
            this.phone = ""
        },
        data: function(type){
            switch (type) {
                case 'create_customer':  return new billingDetails();
                case 'create_user_payment': return new userPaymentDetails();
                case 'create_guest_payment': return new guestPaymentDetails();
                default: return 0;
            }
        },
        gateway: function (requestType = "", gateway = "", data) {
            this.requestType = requestType
            this.gateway = gateway
            this.data = data ? data : new InsitesRequestModels.data(requestType)
            this.source = ""
        }
    }
})()
window.InsitesRequestModels = InsitesRequestModels;

import OnlineRenewalCardDetails from '@/components/OnlineRenewalCardDetails.vue'

export default {
    components: {
        OnlineRenewalCardDetails
    },
    props: {
        show: {
            default: false,
            type: Boolean
        }
    },
    mounted() {
    },
    methods: {
        /**
         * Resets the Stripe elements in the Card Details Component
         */
        resetCardDetails: function(){
            this.$refs.cardDetailsRef.reset();
        },

        /**
         * Creates a Notication message
         * @param {String} type         the type of the notification message (determines the color and icon of the notification)
         * @param {String} title        the title of the notication
         * @param {String} content      notication details
         */
        notify: function (type, title, content) {
            this.$notification[type]({ message: title, description: content });
            if (type === "error") this.isLoading = false;
        },

        /**
         * Sends the request to Stripe to create customer
         */
        submitForm: async function () {
            var token = await this.$refs.cardDetailsRef.createToken();
            if (token.state) {
                var request = new InsitesRequestModels.gateway("create_customer", "insites_stripe"),
                riskAddress = JSON.parse(this.$store.state.sessionDetails.properties.insured_address);
                request.source = token.result.id;
                request.data = {
                    customer: {
                        id: this.$store.state.sessionDetails.user_id,
                        email: this.$store.state.sessionDetails.properties.email,
                        lastName: this.$store.state.sessionDetails.properties.last_name,
                        firstName: this.$store.state.sessionDetails.properties.first_name,
                        phone: this.$store.state.sessionDetails.properties.home_phone_number
                    },
                    address: {
                        isSaveBilling: false,
                        address1: riskAddress.address1,
                        address2: riskAddress.address2,
                        city: "",
                        address_state: riskAddress.state,
                        post_code: riskAddress.postcode,
                        country: "Australia"
                    }
                }
                let payload = {
                    method: 'post',
                    url: `${this.baseURL}/main/add_stripe_customer.json`,
                    data: request
                };
                
                return await this.$store.dispatch('fetchData', payload)
                .then(response => {
                    let result = response.data.properties;
                    if(result.request_errors && !result.response) {
                        this.filterError(result.request_errors);
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: result.request_errors
                        });
                        //parent.toastr.error(result.request_errors);
                        return { state: false, result: result }
                    } else {
                        parent.toastr.success("Card has been successfully added")
                        let return_value = { state: true, result: result }
                        return return_value;
                    }
                }).catch(error => {
                    return { state: false, result: "" }
                })
                    
            } else return token
        },

        filterError: function(err){
            let message = err;
            if (err.includes("Invalid API Key")){
                message = "Invalid API Key."
            } else if (err.includes("No such customer")){
                message = "Your account was not found on the Gateway."
            } else if (err.includes("No such source") || err.includes("No such token")){
                message = "Your card was not found on the Gateway."
            }
            message += " Please contact the website administrator.";
            // this.notify("error", "Error", message)
            parent.toastr.error(message);
        },
    }
}
</script>